// Shared color palette for Sticky Notes (soft paper look).
export const NOTE_COLORS = {
  yellow: {
    name: 'Yellow',
    card: 'bg-amber-100 border-amber-200 hover:border-amber-300',
    solid: 'bg-amber-300',
    text: 'text-amber-900',
  },
  blue: {
    name: 'Blue',
    card: 'bg-sky-100 border-sky-200 hover:border-sky-300',
    solid: 'bg-sky-300',
    text: 'text-sky-900',
  },
  green: {
    name: 'Green',
    card: 'bg-emerald-100 border-emerald-200 hover:border-emerald-300',
    solid: 'bg-emerald-300',
    text: 'text-emerald-900',
  },
  grey: {
    name: 'Grey',
    card: 'bg-slate-100 border-slate-200 hover:border-slate-300',
    solid: 'bg-slate-300',
    text: 'text-slate-800',
  },
  purple: {
    name: 'Purple',
    card: 'bg-violet-100 border-violet-200 hover:border-violet-300',
    solid: 'bg-violet-300',
    text: 'text-violet-900',
  },
  pink: {
    name: 'Pink',
    card: 'bg-pink-100 border-pink-200 hover:border-pink-300',
    solid: 'bg-pink-300',
    text: 'text-pink-900',
  },
  orange: {
    name: 'Orange',
    card: 'bg-orange-100 border-orange-200 hover:border-orange-300',
    solid: 'bg-orange-300',
    text: 'text-orange-900',
  },
};

export const COLOR_KEYS = Object.keys(NOTE_COLORS);

export const getColor = (key) => NOTE_COLORS[key] || NOTE_COLORS.yellow;
